<template>
  <div class="notfound">
    <global-header :linkShow="linkShow"></global-header>
    <div class="content">
      <img src="./404.png" alt="not-found" width="250" height="120" class="notfound-img">
      <p class="para">出错了</p>
      <p class="para">您访问的页面出现了一点问题</p>
      <a href="/" class="linkback">返回首页</a>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script>
  import footNav from 'components/footnav/FootNav'
  import globalHeader from 'components/globalheader/GlobalHeader'
  export default {
    data() {
      return {
        linkShow: false,
      }
    },
    components: {
      globalHeader,
      footNav
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
  .notfound {
    padding-top: 124px
    position: relative
    background #f2f2f2
    .content {
      min-height: calc(100vh - 509px)
      margin-top: 10px
      padding-bottom: 220px
      text-align: center
      box-sizing border-box
      background: #fff
      .notfound-img {
        margin: 130px 0 20px
      }
      .para {
        margin-top: 10px
        font-size: 18px
        color: #b5b5b5
        height: 25px
        line-height: 25px
      }
      .linkback {
        display: inline-block
        margin-top: 20px
        width: 126px
        height: 36px
        font-size: 16px
        color: #ffffff
        line-height: 36px
        text-align: center
        background: #ff6700
        border-radius: 4px
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/notfound/404.vue